import { Typography } from "@mui/material";
import Link from "next/link";
import Card from "./Card";

export default function MarvyVerticalMenu({ items, ...props }) {
  return (
    <Card {...props}>
      {items.map((item) => {
        const label = (
          <Typography
            onClick={item.onClick}
            sx={{
              fontSize: 16,
              lineHeight: 1.36,
              fontWeight: 700,
              color: "dark.main",
              cursor: "pointer",
            }}
          >
            {item.label}
          </Typography>
        );
        if (item.href) {
          if (item.target) {
            return (
              <a href={item.href} target={item.target}>
                {label}
              </a>
            );
          } else {
            return <Link href={item.href}>{label}</Link>;
          }
        } else {
          return label;
        }
      })}
    </Card>
  );
}
